import styled, { css } from 'styled-components/native';
import { RFValue } from 'react-native-responsive-fontsize';
import { Platform } from 'react-native';
import { getBottomSpace } from 'react-native-iphone-screen-helper';

interface CheckProps {
  checked?: boolean;
  locked?: boolean;
}

interface StatusBadgeProps {
  status: 'Vencido' | 'A vencer';
}

interface MasterCheckBoxProps {
  state: 'all' | 'some' | 'none';
}

export const Container = styled.View`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;
  padding: 0 ${RFValue(20)}px;
`;

export const SectionScroll = styled.ScrollView`
  flex: 1;
`;

/* ── Vehicle chip ─────────────────────────────────── */

export const VehicleBadge = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(10)}px;
  background-color: ${({ theme }) => theme.colors.background_secondary};
  border-radius: ${RFValue(12)}px;
  padding: ${RFValue(10)}px ${RFValue(14)}px;
  margin-top: ${RFValue(8)}px;
  margin-bottom: ${RFValue(8)}px;
`;

export const VehicleInfo = styled.View`
  flex: 1;
`;

export const VehicleName = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
  color: ${({ theme }) => theme.colors.title};
`;

export const VehiclePlate = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
  color: ${({ theme }) => theme.colors.title};
`;

export const VehicleModel = styled.Text`
  font-size: ${RFValue(11)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.text};
  margin-top: ${RFValue(1)}px;
`;

/* ── Select all bar ───────────────────────────────── */

export const SelectAllBar = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(12)}px;
  background-color: ${({ theme }) => theme.colors.background_secondary};
  border-top-left-radius: ${RFValue(10)}px;
  border-top-right-radius: ${RFValue(10)}px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  padding: ${RFValue(11)}px ${RFValue(14)}px;
`;

export const MasterCheckBox = styled.View<MasterCheckBoxProps>`
  width: ${RFValue(20)}px;
  height: ${RFValue(20)}px;
  border-radius: ${RFValue(4)}px;
  border-width: 2px;
  align-items: center;
  justify-content: center;
  ${({ state, theme }) =>
    state === 'none'
      ? css`
          border-color: ${theme.colors.border};
          background-color: transparent;
        `
      : css`
          border-color: ${theme.colors.blue};
          background-color: ${theme.colors.blue};
        `}
`;

export const SelectAllText = styled.Text`
  flex: 1;
  font-size: ${RFValue(12)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
  color: ${({ theme }) => theme.colors.text_dark};
`;

export const SelectAllCount = styled.Text`
  font-size: ${RFValue(11)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.text};
`;

export const SelectAllDivider = styled.View`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.border};
  margin-bottom: ${RFValue(4)}px;
`;

/* ── Sections & items ─────────────────────────────── */

export const Section = styled.View`
  margin-bottom: ${RFValue(6)}px;
`;

export const SectionTitle = styled.Text`
  font-size: ${RFValue(10)}px;
  font-family: ${({ theme }) => theme.fonts.bold};
  color: ${({ theme }) => theme.colors.text};
  letter-spacing: 0.8px;
  text-transform: uppercase;
  padding: ${RFValue(14)}px 0 ${RFValue(4)}px;
`;

export const Item = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${RFValue(13)}px 0;
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.colors.border3};
`;

export const LeftContent = styled.View`
  flex-direction: row;
  align-items: center;
  flex: 1;
`;

export const CheckBox = styled.View<CheckProps>`
  width: ${RFValue(20)}px;
  height: ${RFValue(20)}px;
  border-radius: ${RFValue(4)}px;
  border-width: 2px;
  border-color: ${({ checked, locked, theme }) =>
    locked ? theme.colors.border : checked ? theme.colors.blue : theme.colors.border};
  background-color: ${({ checked, locked, theme }) =>
    locked ? theme.colors.border : checked ? theme.colors.blue : 'transparent'};
  align-items: center;
  justify-content: center;
`;

export const Infos = styled.View`
  margin-left: ${RFValue(12)}px;
  flex: 1;
`;

export const Title = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
  color: ${({ theme }) => theme.colors.text_dark};
`;

export const StatusBadge = styled.Text<StatusBadgeProps>`
  align-self: flex-start;
  font-size: ${RFValue(9)}px;
  font-family: ${({ theme }) => theme.fonts.bold};
  border-radius: ${RFValue(4)}px;
  overflow: hidden;
  padding: ${RFValue(2)}px ${RFValue(6)}px;
  margin-top: ${RFValue(3)}px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  ${({ status, theme }) =>
    status === 'Vencido'
      ? css`
          color: ${theme.colors.background};
          background-color: ${theme.colors.attention};
        `
      : css`
          color: ${theme.colors.text_dark};
          background-color: ${theme.colors.gold};
        `}
`;

export const RightContent = styled.View`
  align-items: flex-end;
  margin-left: ${RFValue(12)}px;
`;

export const Value = styled.Text`
  font-size: ${RFValue(13)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
  color: ${({ theme }) => theme.colors.title};
`;

export const ItemDate = styled.Text`
  font-size: ${RFValue(10)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.text};
  text-transform: capitalize;
  margin-top: ${RFValue(2)}px;
`;

/* ── Footer ───────────────────────────────────────── */

export const Footer = styled.View`
  padding: ${RFValue(16)}px ${RFValue(20)}px 0;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
  border-top-width: 1px;
  border-top-color: ${({ theme }) => theme.colors.border};
`;

export const FooterTotal = styled.View`
  margin-bottom: ${RFValue(14)}px;
`;

export const FooterTotalLabel = styled.Text`
  font-size: ${RFValue(11)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.text};
`;

export const FooterTotalValue = styled.Text`
  font-size: ${RFValue(20)}px;
  font-family: ${({ theme }) => theme.fonts.bold};
  color: ${({ theme }) => theme.colors.title};
`;

/* ── Legacy (não removidos para não quebrar outros usos) ── */

export const SectionHeader = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: ${RFValue(4)}px 0px;
`;

export const LinkButton = styled.TouchableOpacity``;

export const LinkButtonText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
  color: ${({ theme }) => theme.colors.blue};
  text-decoration-line: underline;
`;

export const TitleRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${RFValue(12)}px;
`;

export const TitleText = styled.Text`
  font-size: ${RFValue(16)}px;
  font-family: ${({ theme }) => theme.fonts.bold};
  color: ${({ theme }) => theme.colors.title};
  flex: 1;

`;

export const SenatranBadge = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(4)}px;
`;

export const SenatranSelo = styled.Image`
  width: ${RFValue(16)}px;
  height: ${RFValue(18)}px;
`;

export const SenatranTextWrapper = styled.View``;

export const SenatranLabel = styled.Text`
  font-size: ${RFValue(7)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: -${RFValue(3)}px;
`;

export const SenatranTitle = styled.Text`
  font-size: ${RFValue(10)}px;
  font-family: ${({ theme }) => theme.fonts.bold};
  color: #5a7a2b;
`;
